<div class="installation-container">
  @if (featureSettingsService.poseEnabled) {
  <div class="body-header">
    <span class="casto-title large" [innerHTML]="'installation.carpentry.title' | translate"></span>
  </div>
  @if (currentInstallation?.withInstallation) {
    <div class="panel">
      <div class="panel-content">
        <div class="casto-card">
          <div class="header">
            @if ((currentPricing && !currentPricing.delta?.actualAmount) ||
            more2Years === undefined ||
            loading ||
            pricingLoading) {
              <span
                class="casto-title"
                [innerHTML]="'installation.carpentry.with-installation.title-without-delta' | translate"></span>
            } @else {
              <span
                class="casto-title"
                [innerHTML]="
                  'installation.carpentry.with-installation.title'
                    | translate
                      : {
                          amount: currentPricing?.delta?.actualAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr',
                        }
                "></span>
            }
          </div>
          <div class="content">
            <div class="action">
              <span class="action-label" [innerHTML]="'project-info.more-2-years' | translate"></span>
              <p-selectButton
                [options]="more2YearsOptions"
                [(ngModel)]="more2Years"
                optionLabel="label"
                optionValue="value"
                (onChange)="$event.value !== undefined ? setMore2Years($event.value) : null">
                <ng-template let-item pTemplate>
                  <span [innerHTML]="'generic.' + item.label | translate"></span>
                </ng-template>
              </p-selectButton>
            </div>
            @if (loading) {
              <div class="loader-container">
                <ng-casto-loader></ng-casto-loader>
              </div>
            } @else if (more2Years !== undefined) {
              <table class="price-table">
                <tr class="top-row">
                  <td>
                    <span
                      class="casto-title"
                      [innerHTML]="
                        'installation.carpentry.with-installation.top-row-title'
                          | translate
                            : {
                                tva: this.currentInstallation.more2Years ? 10 : 20,
                              }
                      "></span>
                  </td>
                  <td>
                  </td>
                  <td>
                  </td>
                  <td>
                    <span
                      class="blue"
                      [innerHTML]="
                        currentPricing.totalWithoutFunding.actualAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                      ">
                    </span>
                  </td>
                </tr>

                <!-- Ligne dédiée pour le sous-tableau -->
                <tr>
                  <td class="inner-table-cell">
                    <table class="inner-table">
                      @for (detail of currentPricing.detailConception | keyvalue; track detail.key) {
                        <tr>
                          <td [innerHTML]="'installation.carpentry.conception-details.' + detail.key | translate"></td>

                          <td>
                          </td>
                          <td>
                          </td>
                          <td class="price">
                            <span [innerHTML]="detail.value.actualAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'">
                            </span>
                          </td>
                        </tr>
                      }
                    </table>
                  </td>
                </tr>
                @if (currentPricing.totalInstallation) {
                  <tr>
                    <td>
                      <div class="horizontal-align-with-gap">
                        <span [innerHTML]="'installation.carpentry.with-installation.installation' | translate"></span>
                        <ng-casto-button
                          class="secondary"
                          (click)="openDetail()"
                          [label]="'installation.carpentry.with-installation.details' | translate"></ng-casto-button>
                      </div>
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                      <span
                        class="blue"
                        [innerHTML]="
                          currentPricing.totalInstallation.actualAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                        ">
                      </span>
                    </td>
                  </tr>
                }

                <tr class="white">
                  <span class="ml" [innerHTML]="'installation.ml' | translate"></span>
                </tr>
              </table>
            }
          </div>
        </div>
      </div>
    </div>
    <div class="panel" id="installation">
      <div class="panel-content selectable" (click)="setWithInstallation(false)">
        <div class="casto-card">
          <div class="header">
            <span
              class="casto-title"
              [innerHTML]="'installation.carpentry.without-installation.title' | translate"></span>

            <ng-casto-button
              class="primary"
              [label]="'generic.details' | translate"
              (click)="setWithInstallation(true)"></ng-casto-button>
          </div>
        </div>
      </div>
    </div>
  }
  @if (!currentInstallation?.withInstallation) {
    <div class="panel" id="installation">
      <div class="panel-content selectable" (click)="setWithInstallation(true)">
        <div class="casto-card">
          <div class="header">
            @if ((currentPricing && !currentPricing.delta?.actualAmount) ||
            more2Years === undefined ||
            loading ||
            pricingLoading) {
              <span
                class="casto-title"
                [innerHTML]="'installation.carpentry.with-installation.title-without-delta' | translate"></span>
            } @else {
              <span
                class="casto-title"
                [innerHTML]="
                  'installation.carpentry.with-installation.title'
                    | translate
                      : {
                          amount: currentPricing?.delta?.actualAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr',
                        }
                "></span>
            }
            <ng-casto-button
              class="primary"
              [label]="'generic.details' | translate"
              (click)="setWithInstallation(true)"></ng-casto-button>
          </div>
        </div>
      </div>
    </div>
    <div class="panel">
      <div class="panel-content">
        <div class="casto-card">
          <div class="header">
            <span
              class="casto-title"
              [innerHTML]="'installation.carpentry.without-installation.title' | translate"></span>
          </div>
          @if (!currentInstallation?.withInstallation) {
            <div class="content">
              @if (loading || !currentPricing || pricingLoading) {
                <div class="loader-container">
                  <ng-casto-loader></ng-casto-loader>
                </div>
              } @else {
                <table class="price-table">
                  <tr class="top-row">
                    <td>
                      <span
                        class="casto-title"
                        [innerHTML]="'installation.carpentry.without-installation.top-row-title' | translate"></span>
                    </td>
                    <td>
                    </td>
                    <td>
                    </td>
                    <td>
                      <span
                        class="blue"
                        [innerHTML]="
                          currentPricing.totalWithoutFunding.actualAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                        ">
                      </span>
                    </td>
                  </tr>

                  <!-- Ligne dédiée pour le sous-tableau -->
                  <tr>
                    <td class="inner-table-cell">
                      <table class="inner-table">
                        @for (detail of currentPricing.detailConception | keyvalue; track detail.key) {
                          <tr>
                            <td [innerHTML]="'installation.carpentry.conception-details.' + detail.key | translate"></td>

                            <td>
                            </td>
                            <td>
                            </td>
                            <td class="price">
                              <span
                                [innerHTML]="detail.value.actualAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'">
                              </span>
                            </td>
                          </tr>
                        }
                      </table>
                    </td>
                  </tr>


                  <tr class="white">
                    <span class="ml" [innerHTML]="'installation.ml' | translate"></span>
                  </tr>
                </table>
              }
            </div>
          }
        </div>
      </div>
    </div>
  }
  } @else {
    <div class="panel feature-disabled-panel">
      <div class="panel-content">
        <div class="alert alert-warning m-0 text-center" [innerHTML]="'feature-settings.warning.pose' | translate"></div>
      </div>
    </div>
  }
</div>
